import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { SharedService } from "../services/shared.service";
@Component({
  selector: 'redirect',
  template: ``
})
export class RedirectComponent implements OnInit {

  constructor(
    private _router: Router,
    private _cookieService: CookieService,
    private _sharedService: SharedService
  ) { }

  ngOnInit() {
    const isLoggedIn = this._cookieService.get('isLoggedIn');
    const isSupserUser = this._cookieService.get('super_admin');

    if (isLoggedIn === "true") {
      let orgCode = localStorage.getItem("organizationCode");
      if (!orgCode) {
        window["_app_base"] = "";
        const url = this._router.serializeUrl(this._router.createUrlTree(['not-found']));
        window.open(url, '_self');
        return;
      }
      const url = this._router.serializeUrl(this._router.createUrlTree([orgCode + '/dashboard']));
      window.open(url, "_self");
      return;
    } else if (isLoggedIn === "true" && isSupserUser === "true") {
      const url = this._router.serializeUrl(this._router.createUrlTree(['/organizations']));
      window.open(url, "_self");
    } else {
      this._router.navigateByUrl('/login');
    }
  }

}
